module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-04-8c2ff28b15045d79c0e8f534296fa96f.png";